var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c(
          "el-form",
          { attrs: { "label-width": "133px", "label-position": "right" } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_CustomsDeclarationInformation")
                }
              },
              [
                _c("span", { staticStyle: { color: "#919191" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_QuantityWeightCubage") +
                        _vm.$t("CargoMsg.Cargo_SubTotal")
                    ) +
                      "：" +
                      _vm._s(_vm.total)
                  )
                ])
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              staticStyle: {
                width: "100%",
                height: "200px",
                "margin-top": "5px"
              },
              attrs: {
                "config-module": "13011601",
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.job.poItems || []
              },
              on: { gridReady: _vm.onGridReady }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { "text-align": "right", "margin-bottom": "5px" } },
          [
            _c(
              "el-button",
              {
                attrs: { disabled: !_vm.isEditing, type: "primary", no: "1" },
                on: { click: _vm.add }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
            ),
            _c(
              "el-button",
              {
                attrs: { disabled: !_vm.isEditing, type: "danger", no: "2" },
                on: { click: _vm.remove }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }